export default "__VITE_PUBLIC_ASSET__6d89473a__"